import { Component, OnInit } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { SortableExtractor } from '@common/UI/sortable/sortable.component';
import { Filterable } from '@common/utilities/Filterable';
import { CurrenciesService } from '@core/services/currencies.service';
import { DataService, parts2SKU, ProductRecord, ProductUnit } from '@core/services/data.service';
import { ProductsService } from '@core/services/products.service';
import { SynchronizationService } from '@core/services/synchronization.service';
import { UsersService } from '@core/services/users.service';
import { MessageBoxService } from '@routes/common/message-box.service';
import { ProductEditorComponent } from '@routes/editors/product-editor/product-editor.component';
import { TextEditorComponent } from '@routes/editors/text-editor/text-editor.component';
import { map } from 'rxjs/operators';

function int(v: string): number {

  let test = parseInt(v.replace(/([^0-9])/g, ''));

  return isNaN(test) ? Infinity : test;
}

@Component({
  selector: 'products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  constructor(private ds: DataService, private users: UsersService, private currencyService: CurrenciesService, private productService: ProductsService, private sync: SynchronizationService, private modal: ModalService, private mb: MessageBoxService) { }

  public import(text: string = '[NHÀ CUNG CẤP] [MÃ HÀNG] [MÀU1 MÀU2...] [GIÁ NHẬP] [LÃI XUẤT] [PHÍ VẬN CHUYỂN]') {

    this.modal.show(TextEditorComponent, { state: { title: 'Tạo mã hàng thủ công', text: text } }).content.commit.subscribe(text => {

      this.productService.synchronize();

      this.sync.when(ProductsService).commit(() => {

        let records: { [key: string]: { id: number, sku: string, color: string, fee: number, profit: number, price: number, updated: boolean, original: ProductRecord } } = {};

        this.productService.all.forEach(product => {
          product.Colors.forEach(info => {
            let key = [product.SKU, info.Color].join('/');
            records[key] = { id: product.ID, sku: product.SKU, color: info.Color, fee: product.LogisticsMargin, profit: product.ProfitMargin, price: product.UnitPrice, updated: false, original: product };
          });
        })

        let lines = text.split('\n');        

        for (let line of lines) {

          let cols = line.split('\t');

          if (cols.length < 6) continue;

          let sku = parts2SKU(cols[0].trim(), cols[1].trim().replace(/(#)/i, ''));
          let colors = cols[2].split(/( |\n|\r)/i).filter(i => i.trim().length > 0).map(i => i.split(/(-|~|号)/i)[0].replace(/(#)/i, ''));
          let price = parseFloat(cols[3]);
          let profit = parseFloat(cols[4]) / 100;
          let fee = parseFloat(cols[5]);

          if (sku.length > 0 && colors.length > 0 && profit >= 0 && fee >= 0) {

            for (let color of colors) {
              let key = [sku, color].join('/');

              if (!records[key]) {
                records[key] = { id: 0, sku: sku, color: color, price: price, profit: profit, fee: fee, updated: true, original: null }
              }
              else {
                records[key].price = price;
                records[key].profit = profit;
                records[key].fee = fee;
                records[key].updated = true;
              }
            }
          }
        }

        let data: { id: number, sku: string, color: string, fee: number, profit: number, price: number, updated: boolean, original: ProductRecord }[] = [];

        for (let o in records) data.push(records[o]);

        data.group(i => i.id).filter(g => g.key as number > 0 && g.items.first(i => i.updated, null) != null).forEach(group => {

          let chosen = group.items.first(i => i.updated);

          group.items.forEach(item => {
            if (!item.updated) {
              item.price = chosen.price;
              item.profit = chosen.profit;
              item.fee = chosen.fee;
              item.updated = true;
            }
          });
        });
        
        let updates: { [key: number]: ProductRecord } = {};
        let adds: ProductRecord[] = [];
        let rmvs: ProductRecord[] = [];
        let news: ProductRecord[] = [];

        data.group(i => [i.sku, i.price, i.profit, i.fee].join('/')).filter(i => i.items.first(x => x.updated, null) != null).forEach(group => {

          let chosen = group.items.group(i => i.id).order(i => i.items.length, 'descending').first(i => i.key as number > 0, { key: 0, items: [] }).items.first();

          if (chosen) {

            if (!updates[chosen.id]) {
              updates[chosen.id] = { ...chosen.original };
              rmvs.remove(updates[chosen.id]);
              adds.push(updates[chosen.id]);
            }

            updates[chosen.id].ProfitMargin = chosen.profit;
            updates[chosen.id].LogisticsMargin = chosen.fee;
            updates[chosen.id].UnitPrice = chosen.price;

            group.items.forEach(record => {

              if (record.id != chosen.id) {

                if (record.id > 0) {
                  if (!updates[record.id]) {
                    updates[record.id] = { ...record.original };
                    rmvs.push(updates[record.id]);
                  }

                  updates[record.id].Colors = updates[record.id].Colors.filter(i => i.Color != record.color);
                }

                record.id = chosen.id;
                updates[chosen.id].Colors.push({ Available: 0, Color: record.color });
              }
            });
          }
          else {
            news.push({ ID: 0, SKU: group.items[0].sku, Colors: group.items.map(i => ({ Available: 0, Color: i.color })), ProfitMargin: group.items[0].profit, LogisticsMargin: group.items[0].fee, UnitPrice: group.items[0].price, Unit: ProductUnit.Meter, AverageQuantity: 0, Stamp: new Date().getTime(), IsPriceVerified: false });
          }
        });        

        rmvs.forEach(product => this.sync.with(ProductsComponent).repeat(() => this.ds.products(product.Colors.length > 0 ? 'update' : 'delete', product).pipe(map(data => data && data.length > 0))));

        this.sync.when(ProductsComponent).commit(() => {

          adds.forEach(product => this.sync.with(ProductsComponent).repeat(() => this.ds.products('update', product).pipe(map(data => data && data.length > 0))));

          this.sync.when(ProductsComponent).commit(() => {

            news.forEach(product => this.sync.with(ProductsComponent).repeat(() => this.ds.products('update', product).pipe(map(data => data && data.length > 0))));

            if (rmvs.length + adds.length + news.length > 0) this.sync.when(ProductsComponent).commit(() => this.synchronize());
          });
        });
      });
    });
  }


  public get isAdmin(): boolean {
    return this.users.current && this.users.current.Roles.containsAny("Owner", "Admin");
  }

  public get loading(): boolean {
    return !this.sync.ready(ProductsService, CurrenciesService);
  }

  public products = new Filterable<ProductRecord>({
    extractor: i => [i.SKU]
  });

  public extractor(field: string): SortableExtractor<ProductRecord> {
    return {
      extract: i => {
        switch (field) {
          case "Colors": return i.Colors.length;
          case "QuotePrice": return this.quote(i);
          default: return i[field];
        }
      }
    };
  }

  public get exchange(): number {
    return this.currencyService.get('CNY').Conversion;
  }

  public synchronize() {
   
    this.productService.synchronize();
    this.currencyService.synchronize();

    this.sync.when(UsersService, CurrenciesService, ProductsService).commit(() => {

      let products = this.productService.all;
      products.forEach(i => i.Colors = i.Colors.order(i => int(i.Color)));
      this.products.source = products;
    });
  }

  public quote(product: ProductRecord): number {
    return product.UnitPrice == 0 ? 0 : Math.ceil((product.UnitPrice * (1 + product.ProfitMargin) + product.LogisticsMargin) * this.currencyService.get("CNY").Conversion / 500) * 500;
  }

  ngOnInit(): void {

    this.synchronize();
  }

  public edit(product: ProductRecord) {

    if (this.isAdmin) {
      this.modal.show(ProductEditorComponent, {
        state: {
          product: product,
          onSucceed: product => this.synchronize()
        }
      });
    }    
  }

  public copy(product: ProductRecord) {

    if (this.isAdmin) {

      this.modal.show(ProductEditorComponent, {
        state: {
          product: { ...product, ID: 0 },
          onSucceed: product => this.synchronize()
        }
      });
    }
  }

  public deletable(product: ProductRecord): boolean {
    return product.Colors.sum(i => i.Available) == 0;
  }

  public delete(product: ProductRecord) {

    if (this.isAdmin && this.deletable(product)) {
      this.mb.confirms('discourage', "Bạn muốn xóa mã hàng " + product.SKU + "?", () => this.ds.products('delete', product).pipe(map(products => {

        let result = products && products.length == 1;
        if (result) this.synchronize();

        return result;
      })));
    }
  }
}
